import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/mobile-app.css";
import "./App.css";

// Admin Components
import AdminDashboard from "./components/admin/AdminDashboard";
import StockManagement from "./components/admin/StockManagement";
import BillingManagement from "./components/admin/BillingManagement";
import BillingHistory from "./components/admin/BillingHistory";
import CustomerManagement from "./components/admin/CustomerManagement";
import OrderManagement from "./components/admin/OrderManagement";
import CreditManagement from "./components/admin/CreditManagement";
import RatesManagement from "./components/admin/RatesManagement";
import ConfigManagement from "./components/admin/ConfigManagement";
import AnalyticsDashboard from "./components/admin/AnalyticsDashboard";
import IncomeExpenseManagement from "./components/admin/IncomeExpenseManagement";
import RateLimitManagement from "./components/admin/RateLimitManagement";
import QRCodePrint from "./components/admin/QRCodePrint";
import ReceiptPrintPage from "./components/admin/ReceiptPrintPage";
import DaySessionManagement from "./components/admin/DaySessionManagement";
import LowStockAlerts from "./components/admin/LowStockAlerts";
import ReturnsManagement from "./components/admin/ReturnsManagement";
import PromoCodeManagement from "./components/admin/PromoCodeManagement";
import GiftVoucherManagement from "./components/admin/GiftVoucherManagement";
import LayawayManagement from "./components/admin/LayawayManagement";
import CustomerLedger from "./components/admin/CustomerLedger";

// Customer Website Components
import CustomerHome from "./components/customer/CustomerHome";
import ProductCatalog from "./components/customer/ProductCatalog";
import Checkout from "./components/customer/Checkout";
import OrderStatus from "./components/customer/OrderStatus";
import LiveRates from "./components/customer/LiveRates";
import GoldMine from "./components/customer/GoldMine";
import GoldReserve from "./components/customer/GoldReserve";
import Account from "./components/customer/Account";

// Auth Components
import Login from "./components/user/login.component";
import Register from "./components/user/register.component";

function App() {
  return (
        <HelmetProvider>
      <BrowserRouter>
        <Routes>
          {/* Customer Website Routes */}
          <Route path="/" element={<CustomerHome />} />
          <Route path="/products" element={<ProductCatalog />} />
          <Route path="/live-rates" element={<LiveRates />} />
          <Route path="/account" element={<Account />} />
          <Route path="/gold-mine" element={<GoldMine />} />
          <Route path="/gold-reserve" element={<GoldReserve />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/:orderId" element={<OrderStatus />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/day-session" element={<DaySessionManagement />} />
          <Route path="/admin/stock" element={<StockManagement />} />
          <Route path="/admin/low-stock" element={<LowStockAlerts />} />
          <Route path="/admin/qr-print" element={<QRCodePrint />} />
          <Route path="/admin/print-receipt/:billId/:type" element={<ReceiptPrintPage />} />
          <Route path="/admin/billing" element={<BillingManagement />} />
          <Route path="/admin/billing-history" element={<BillingHistory />} />
          <Route path="/admin/returns" element={<ReturnsManagement />} />
          <Route path="/admin/customers" element={<CustomerManagement />} />
          <Route path="/admin/customers/:id/ledger" element={<CustomerLedger />} />
          <Route path="/admin/orders" element={<OrderManagement />} />
          <Route path="/admin/credits" element={<CreditManagement />} />
          <Route path="/admin/layaway" element={<LayawayManagement />} />
          <Route path="/admin/promo-codes" element={<PromoCodeManagement />} />
          <Route path="/admin/gift-vouchers" element={<GiftVoucherManagement />} />
          <Route path="/admin/analytics" element={<AnalyticsDashboard />} />
          <Route path="/admin/income-expense" element={<IncomeExpenseManagement />} />
          <Route path="/admin/rates" element={<RatesManagement />} />
          <Route path="/admin/config" element={<ConfigManagement />} />
          <Route path="/admin/rate-limit" element={<RateLimitManagement />} />
          </Routes>
      </BrowserRouter>
        </HelmetProvider>
  );
}

export default App;
